import "./project-loader.css";

type ProjectLoaderProps = {
    label?: string;
    compact?: boolean;
};

export const ProjectLoader = ({ label = "Carregando", compact = false }: ProjectLoaderProps) => (
    <div className={compact ? "project-loader is-compact" : "project-loader"} role="status" aria-label={label}>
        <img src="/assets/logo-inteira.png" alt="" className="project-loader-logo" aria-hidden="true" />
        <span className="project-loader-label">{label}</span>
    </div>
);
